export enum HttpStatus {
  OK = 200,
  INTERNAL_SERVER_ERROR = 501,
  BAD_REQUEST = 400,
  NOT_FOUND = 404,
  UNAUTHORIZED = 401,
}
